import { render, staticRenderFns } from "./NoteSidebar.vue?vue&type=template&id=559c6ad2&scoped=true"
import script from "./NoteSidebar.vue?vue&type=script&lang=js"
export * from "./NoteSidebar.vue?vue&type=script&lang=js"
import style0 from "./NoteSidebar.vue?vue&type=style&index=0&id=559c6ad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559c6ad2",
  null
  
)

export default component.exports